export interface CanadianPostalCode {
  id: string
  postal_code_can: string
  id_riding: number
  district_name_en: string
  district_name_fr: string
  id_province: string
}

export interface CanadianPostalCodeEntry {
  postal_code_can: string
  id_riding: number
  district_name_en: string
  district_name_fr: string
}

export type CanadianPostalCodeDto = {
  id: string
  postalCodeCan: string
  idRiding: number
  districtNameEn: string
  districtNameFr: string
  idProvince: string
}

export class CanadianPostalCodeDtoFactory {
  static fromDto(canadianPostalCodeDto: CanadianPostalCodeDto): CanadianPostalCode {
    return {
      id: canadianPostalCodeDto.id,
      postal_code_can: canadianPostalCodeDto.postalCodeCan,
      id_riding: canadianPostalCodeDto.idRiding,
      district_name_en: canadianPostalCodeDto.districtNameEn,
      district_name_fr: canadianPostalCodeDto.districtNameFr,
      id_province: canadianPostalCodeDto.idProvince,
    }
  }
}
